<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow"> 
      <!------------------------search---------------------->
	  		<div v-loading="addressloading">
			<el-form :inline="true" class="backborder1 demo-form-inline" size="small">
				<el-form-item v-if="provincelists.length > 0">
					<el-select v-model="query.provinceid" filterable clearable placeholder="请选择省份" @change="changeprovince">	          
						<el-option v-for="(item,index) in provincelists" :label="item.showname" :value="item.id" :key="index">
								<span style="float: left;margin-right:10%;font-size: 13px">{{item.py}}</span>
								<span style="float: left">{{item.name}}</span>
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="citylists.length > 0">
					<el-select v-model="query.cityid" filterable clearable placeholder="请选择市区" @change="changecity">	          
						<el-option v-for="(item,index) in citylists" :label="item.showname" :value="item.id" :key="index">
								<span style="float: left;margin-right:10%;font-size: 13px">{{item.py}}</span>
								<span style="float: left">{{item.name}}</span>
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="townlists.length > 0">
					<el-select v-model="query.townid" filterable clearable placeholder="请选择区域/县城" @change="changetown">	          
						<el-option v-for="(item,index) in townlists" :label="item.showname" :value="item.id" :key="index">
								<span style="float: left;margin-right:10%;font-size: 13px">{{item.py}}</span>
								<span style="float: left">{{item.name}}</span>
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="country.length > 0">
					<el-select v-model="query.countyid" filterable clearable placeholder="请选择区域/县城">	          
						<el-option v-for="(item,index) in country" :label="item.showname" :value="item.id" :key="index">
								<span style="float: left;margin-right:10%;font-size: 13px">{{item.py}}</span>
								<span style="float: left">{{item.name}}</span>
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="danger" icon="el-icon-plus" @click="addgoods">新增商品</el-button>
					<el-button type="primary" icon="el-icon-search" @click="checkgoods">查询</el-button>
					<el-button type="success" icon="el-icon-download" @click="exportgoods">导出</el-button>
				</el-form-item>
			</el-form>
			</div>

			<el-tag type="danger" style="margin-top:10px">温馨提示：由于京东方限制，请单次查询商品不要超过100个</el-tag>

	  		<div class="backborder2" style="margin-top:10px" v-loading="sgoodsloading">
		    	<el-table :data="query.goods" v-loading="ListLoading" ref="multipleTable" tooltip-effect="dark">
				<el-table-column label="商品">
					<template slot-scope="scope">
						<div style="float:left;width:100%;">
							<div style="float:left;width:65px;height:65px;border:1px solid #dddddd;border-radius:5px;display:flex;align-items: center;justify-content: center;background:rgba(221,221,221,.5)">
								<img :id="'listimginfo'+scope.row.id" :src="scope.row.imagePath=='' ? require('../../assets/default_img_mini.png') : scope.row.imagePath" class="cz-mall-goods" style="max-width:80%;max-height:80%"/>
							</div>
							<span style="float:left;margin-left:2%;width:72%;font-size:13px">{{scope.row.name}}</span>
							<span style="float:left;margin-left:2%;width:72%;font-size:13px;color:rgb(144, 147, 153);">品牌：{{scope.row.brandName}}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="sku" label="sku" width="150"></el-table-column>
				<el-table-column prop="jdprice" label="京东销售价" width="150" align="center"></el-table-column>
				<el-table-column prop="price" label="协议销售价" width="150" align="center"></el-table-column>
				<el-table-column label="数量" width="150" align="center">
					<template slot-scope="scope">
						<el-input v-model="scope.row.nums"></el-input>
					</template>
				</el-table-column>
				<el-table-column prop="hasinventory" label="库存情况" width="150" align="center"></el-table-column>
			</el-table>
	  		</div>
	  
	  <!-- 获取商品信息 -->
	  <el-dialog title="获取京东商品信息" :visible.sync="goodsDialog" width="80%" top="5vh">
	  	  <el-form :inline="true" demo-form-inline size="small">
				<el-form-item>
					<el-select v-model="jdquery.brandid" filterable clearable placeholder="按品牌" @change="changegoods">	          
						<el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
							<span style="float: left">{{item.name}}</span>
							<span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-input placeholder="sku / 商品名称" v-model="jdquery.key" clearable @keyup.enter.native="getList" @change="isselect=true"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
				</el-form-item>
      		</el-form>

			<el-table :data="lists" v-loading="ListLoading" ref="multipleTable" tooltip-effect="dark" @row-click="handleSelectRow" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="50"></el-table-column>
				<el-table-column label="商品">
					<template slot-scope="scope">
						<div style="float:left;width:100%;">
							<div style="float:left;width:65px;height:65px;border:1px solid #dddddd;border-radius:5px;background:rgba(221,221,221,.5);display:flex;align-items: center;justify-content: center;">
								<img :id="'imginfo'+scope.row.id" :src="scope.row.imagePath=='' ? require('../../assets/default_img_mini.png') : scope.row.imagePath" class="cz-mall-goods"	style="max-width:80%;height:80%"/>
							</div>
							<span style="float:left;margin-left:2%;width:72%;font-size:13px">{{scope.row.name}}</span>
							<span style="float:left;margin-left:2%;width:72%;font-size:13px;color:rgb(144, 147, 153);">品牌：{{scope.row.brandName}}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="sku" label="sku" width="140"></el-table-column>
				<el-table-column prop="jdprice" label="京东销售价" width="140" align="center"></el-table-column>
				<el-table-column prop="price" label="协议销售价" width="140" align="center"></el-table-column>
			</el-table>
			<div class="block">
				<!--分页begin-->
				<el-pagination
						@size-change="querySizeChange"
						@current-change="queryCurrentChange"
						:current-page="jdquery.p"
						:page-sizes="[10, 20, 50]"
						:page-size="jdquery.rollpage"
						layout="total, sizes, prev, pager, next, jumper"
						:total="lists_rows">
				</el-pagination>
				<!--分页end-->
			</div>
			<div slot="footer" class="dialog-footer">
	            <el-button size="small" @click="goodsDialog = false">取 消</el-button>
	            <el-button size="small" type="primary" @click="savegoods">确认</el-button>
	        </div>	      
	  </el-dialog>

  </div>
  </transition>   
</template>

<script>

export default {
  data () {
    return {
      actionauth:'', //操作功能权限
      url:this.GLOBAL.domain+"Jdproduct/index",
      transitionshow:true,
      provincelists:[],
	  citylists:[],
	  townlists:[],
	  country:[],
	  addressloading:false,
	  query: {
		  act:'checkjdinventory',
		  token:this.$cookies.get('token'),
		  provinceid:'',
		  cityid:'',
		  townid:'',
		  countyid:'',
		  goods:[],
	  },
	  tempgoods:[],
	  goodsDialog:false,
	  brandlists:[],
	  brandquery: {
	  	  act:'lists',
		  token:this.$cookies.get('token'),
		  rollpage:100000
	  },
	  ListLoading:false,
	  jdquery: {
	  	  act:'jdlists',
	  	  token:this.$cookies.get('token'),
	  	  brandid:'',
	  	  key:'',
	  	  p:1,
	  	  rollpage:10,
	  },
	  lists:[],
	  lists_rows:0,
	  isselect:false,
	  issingle:false,
	  sgoodsloading:false,
	  exporthead:[],
	  exportfield:[],
	  exportlists:[],
	  exportname:'',
      
    }
  },
  mounted(){
  	  this.getactionauth();
	  this.getProvince(); //获取京东省份信息
	  this.getBrand(); //获取品牌信息
  },
  methods:{
  	
  	/** 获取操作功能权限 **/
  	getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },
    
    /** 获取京东省份信息 **/
	getProvince() {
		this.addressloading=true;
		var resource = this.$resource(this.url);	
	    resource.query({act:'getjdaddressinfos',type:1,token:this.$cookies.get('token')}).then((res) => {
			if(res.data.Result>0){
			    if(res.data.Result=='70001') this.$router.push('/login')
			    this.$message.error(res.data.Message);
				this.addressloading=false;
			}else{
			    this.provincelists = JSON.parse(Base64.decode(res.data.Data));
				this.addressloading=false;
			}
	    }).catch((res) => {
	        this.addressloading=false;	
	    });
	},

	/** 修改已选中的京东的省份信息 **/
	changeprovince() {
		this.query.cityid='';
		this.query.townid='';
		this.query.countyid='';
		this.citylists=[];
		this.townlists=[];
		this.country=[];
		if(this.query.provinceid > 0) this.getCity();
	},

	/** 获取京东城市信息 **/
	getCity() {
		this.addressloading=true;
		var resource = this.$resource(this.url);	
	    resource.query({act:'getjdaddressinfos',type:2,id:this.query.provinceid,token:this.$cookies.get('token')}).then((res) => {
			if(res.data.Result>0){
			    if(res.data.Result=='70001') this.$router.push('/login')
			    this.$message.error(res.data.Message);
				this.addressloading=false;
			}else{
			    this.citylists = JSON.parse(Base64.decode(res.data.Data));
				this.addressloading=false;
			}
	    }).catch((res) => {
	        this.addressloading=false;  	
	    });
	},

	/** 修改已选中的京东城市信息 **/
	changecity() {
		this.query.townid='';
		this.query.countyid='';
		this.townlists=[];
		this.country=[];
		if(this.query.cityid > 0) this.gettown();
	},

	/** 获取京东区域地址信息 **/
	gettown() {
		this.addressloading=true;
		var resource = this.$resource(this.url);	
	    resource.query({act:'getjdaddressinfos',type:3,id:this.query.cityid,token:this.$cookies.get('token')}).then((res) => {
			if(res.data.Result>0){
			    if(res.data.Result=='70001') this.$router.push('/login')
			    this.$message.error(res.data.Message);
				this.addressloading=false;
			}else{
			    this.townlists = JSON.parse(Base64.decode(res.data.Data));
				if(this.townlists.length==0) this.query.townid=0;
				this.addressloading=false;
			}
	    }).catch((res) => {
	        this.addressloading=false;  	
	    });
	},

	/** 修改已选中的京东区域/县城信息 **/
	changetown() {
		this.query.countyid='';
		this.country=[];
		if(this.query.townid > 0) this.getarea();
	},

	/** 获取区域/乡镇信息 **/
	getarea() {
		this.addressloading=true;
		var resource = this.$resource(this.url);	
	    resource.query({act:'getjdaddressinfos',type:4,id:this.query.townid,token:this.$cookies.get('token')}).then((res) => {
			if(res.data.Result>0){
			    if(res.data.Result=='70001') this.$router.push('/login')
			    this.$message.error(res.data.Message);
				this.addressloading=false;
			}else{
			    this.country = JSON.parse(Base64.decode(res.data.Data));
				if(this.country.length==0) this.query.countyid=0;
				this.addressloading=false;
			}
	    }).catch((res) => {
	        this.addressloading=false;
	    });
	},

	//获取品牌
	getBrand(){
	    var resource = this.$resource(this.GLOBAL.domain+"Brand/index");		    
	    resource.query(this.brandquery).then((res) => {
			if(res.data.Result>0){
			    if(res.data.Result=='70001') this.$router.push('/login')
			    this.$message.error(res.data.Message);
			}else{
			    this.brandlists = JSON.parse(Base64.decode(res.data.Data));
			}
	    }).catch((res) => {
	          	
	    });
	},

	/** 获取商品信息 **/
	addgoods() {
		this.goodsDialog=true;
		this.jdquery.brandid='';
		this.jdquery.key='';
		this.jdquery.p=1;
		this.jdquery.rollpage=10;
		this.tempgoods=[];
		this.getList(); //获取京东商品信息
	},

	//获取京东商品信息
	getList(){
		if(this.isselect==true) {
			this.jdquery.p=1;
			this.jdquery.rollpage=10;
		}
	
		this.ListLoading=true;
	    var resource = this.$resource(this.GLOBAL.domain+"product/index");		    
	    resource.query(this.jdquery).then((res) => {
			if(res.data.Result>0){
			    if(res.data.Result=='70001') this.$router.push('/login')
			    this.$message.error(res.data.Message);
			    this.ListLoading=false;
			}else{
			    var result = JSON.parse(Base64.decode(res.data.Data));
				this.lists=[];
				var _this=this;
				result.forEach(function(item,i) {
					var param={id:item.id,imagePath:item.imagePath,name:item.name,sku:item.sku,brandName:item.brandName,price:item.price,jdprice:item.jdprice};
					_this.lists.push(param);
				});
			    this.lists_rows = parseInt(res.data.count);
			    this.ListLoading=false;
			    if(this.isselect==true) this.isselect=false;

				this.issingle=true;
				setTimeout(function() {
					//勾选已选中的商品信息
					_this.lists.forEach(function(t,i) {
						_this.tempgoods.forEach(function(tt,ii) {
							if(t.id==tt.id) _this.$refs.multipleTable.toggleRowSelection(_this.lists[i]);  //勾选/取消勾选选中行状态
						});
					});
					_this.issingle=false;
				},150);

			}
	    }).catch((res) => {
	        this.ListLoading=false;
	    });
	},
	
	querySizeChange(val) {
	    this.jdquery.rollpage = val;
	    this.getList();
	},
	queryCurrentChange(val) {
	    this.jdquery.p = val;
	    this.getList();
	},

	/** 修改品牌信息 **/
	changegoods() {
		this.isselect=true;
		this.getList();
	},

	/** 单行点击选中/取消选择商品 **/
	handleSelectRow(row,event,column) {
		this.issingle=true;
		var id=row.id; //获取商品信息

		//检测其是否在已选择的商品里面，是则需删除，否需添加
		var isexit=-1;
		this.tempgoods.forEach(function(item,i) {if(item.id==id) isexit=i});
		if(isexit==-1) { //不存在，需添加
			this.tempgoods.push({id:row.id,name:row.name,sku:row.sku,imagePath:row.imagePath,price:row.price,jdprice:row.jdprice,brandName:row.brandName});
		}else { //存在，需删除
			//取出商品所在临时存储的位置
			this.tempgoods.forEach(function(item,i) {if(item.id==id) isexit=i});
			this.tempgoods.splice(isexit,1);
		}
		this.$refs.multipleTable.toggleRowSelection(row);  //勾选/取消勾选选中行状态
		this.issingle=false;
	},

	/** 批量点击商品选择 **/
	handleSelectionChange(val) {
		if(this.issingle==true) return false;

		var _this=this;
		//当前可见商品全部取消
		if(val.length==0) {
			//获取当前可见的所有商品id 
			var pids=[];
			this.lists.forEach(function(t,i) {pids.push(t.id)});
			//动态监测，发现有删除的商品在临时缓存里清除
			var numbers=-1;
			pids.forEach(function(tt,ii) {
				numbers=-1;
				this.tempgoods.forEach(function(t,i) {if(tt==t.id) numbers=i});
				if(numbers > -1) this.tempgoods.splice(numbers,1);
			});

		}else { //当前可见商品部分选择，部分取消
			var add=[];
			var del=[];
			var number=-1;

			//可见商品分包
			this.lists.forEach(function(t,i) {
				number=-1;
				val.forEach(function(tt,ii) {if(t.id==tt.id) number=i});
				number==-1 ? del.push(t) : add.push(t);
			});

			//删除已有商品
			del.forEach(function(t,i) {
				number=-1;
				_this.tempgoods.forEach(function(tt,ii) {if(t.id==tt.id) number=ii});
				if(number>-1) _this.tempgoods.splice(number,1);
			});

			//添加没有的商品
			add.forEach(function(t,i) {
				number=-1;
				_this.tempgoods.forEach(function(tt,ii) {if(t.id==tt.id) number=ii});
				if(number==-1) _this.tempgoods.push({id:t.id,name:t.name,sku:t.sku,imagePath:t.imagePath,price:t.price,jdprice:t.jdprice,brandName:t.brandName});
			});
		}
	},


	/** 确认新增查询的商品 **/
	savegoods() {
		if(this.tempgoods.length==0) {this.$message.error('请选择要查询的商品信息');return false;}
		if(this.tempgoods.length>100) {this.$message.error('单次查询商品个数不能超过100个，当前为'+this.tempgoods.length+'个');return false;}
		var _this=this;
		this.query.goods=[];
		this.tempgoods.forEach(function(item,i) {
			_this.query.goods.push({id:item.id,name:item.name,sku:item.sku,imagePath:item.imagePath,price:item.price,jdprice:item.jdprice,brandName:item.brandName,nums:1,hasinventory:''});
		});

		//调整图片适配
		var _this=this;
		var imgs="";
		setTimeout(function() {
			_this.query.goods.forEach(function(e,index){  
				imgs=document.getElementById("listimginfo"+e.id);
				var img = new Image();
				img.src = imgs.src;
				var width='0'; var height="0"; var left="0"; var top="0";
				img.onload = function(){
					img.onload =null;
					callback(img);
				}

				width=img.width; height=img.height;
				if(width/height==1) {
					width=55; height=55;
					left=5;top=5;
				}else if(width/height!=1 && width > height) { //非正方形图片宽大于高时,进行缩小处理
					var newwidth=55; var newheight=newwidth*height/width;
					width=newwidth; height=newheight;
					left=5; top=(65-newheight)/2;

				}else if(width/height!=1 && height > width) { //非正方形图片高大于宽时,进行缩小处理
					var newheight=55; var newwidth=width*newheight/height;
					width=newwidth; height=newheight;
					top=5; left=(65-newwidth)/2
				}
				e.width=width+'px';e.height=height+'px';e.left=left+"px";e.top=top+"px";
			});
			_this.query.goods=JSON.parse(JSON.stringify(_this.query.goods));
		},500);
		this.goodsDialog=false;
	},


	/** 查询当前商品库存信息 **/
	checkgoods() {
		//清空商品库存状态
		var _this=this;
		if(this.query.goods.length==0) {this.$message.error('请选择要查询的商品信息');return false;}
		this.query.goods.forEach(function(item,i) {_this.query.goods[i].hasinventory=''});

		this.sgoodsloading=true;
		var resource = this.$resource(this.url);		    
	    resource.save(this.query).then((res) => {
			if(res.data.Result>0){
			    if(res.data.Result=='70001') this.$router.push('/login')
			    this.$message.error(res.data.Message);
				this.sgoodsloading=false;
			}else{
			    this.query.goods = JSON.parse(Base64.decode(res.data.Data));
				this.sgoodsloading=false;
			}
	    }).catch((res) => {
	        this.sgoodsloading=false;
	    });
	},


	/** 导出商品信息 **/
	exportgoods() {
		if(this.query.goods.length==0) {this.$message.error("请选择要导出的商品信息");return false;}
		var isexport=true;
		this.query.goods.forEach(function(item,i) {if(item.hasinventory=='') isexport=false;});
		if(isexport==false) {this.$message.error("请先搜索商品的库存信息");return false;}

		var provincename='';
		var cityname='';
		var townname='';
		var countyname='';
		var address="";
		var lists=[];
		var _this=this;
		var date=new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate();
		this.provincelists.forEach(function(item,i) {if(item.id==_this.query.provinceid) provincename=item.name});

		this.citylists.forEach(function(item,i) {if(item.id==_this.query.cityid) cityname=item.name});
		this.townlists.forEach(function(item,i) {if(item.id==_this.query.townid) townname=item.name});
		this.country.forEach(function(item,i) {if(item.id==_this.query.countyid) countyname=item.name});
		address="（"+provincename;
		cityname!='' ? address +=" "+cityname : "";
		townname!='' ? address +=" "+townname : "";
		cityname!='' ? address +=" "+cityname : "";
		address +=" "+date+"）";

		//数据头部
		this.query.goods.forEach(function(item,i) {
			lists.push({name:item.name,brandName:item.brandName,sku:item.sku,jdprice:item.jdprice,price:item.price,nums:item.nums,hasinventory:item.hasinventory});
		});
		lists.push({name:address,brandName:'',sku:'',jdprice:'',price:'',nums:'',hasinventory:''});

		this.exporthead=['商品名称','品牌','sku','京东销售价','协议销售价','数量','库存情况'];
	    this.exportfield=['name','brandName','sku','jdprice','price','nums','hasinventory'];
	    this.exportlists=lists;
	    this.exportname='京东商品库存信息';
	    this.exportput();
	},

	/** 确认导出信息 **/
    exportput() {
		require.ensure([], () => {
			var { export_json_to_excel } = require('../../vendor/Export2Excel');
			var data = this.formatJson(this.exportfield, this.exportlists);
			export_json_to_excel(this.exporthead, data, this.exportname);
		})
    },
    
    //导出表格数据
	formatJson(filterVal, jsonData) {
　　　　return jsonData.map(v => filterVal.map(j => v[j]));
　　}, 

  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.cz-mall-goods {float:left;border-radius:5px}
</style>


// WEBPACK FOOTER //
// src/components/inventory/Jdinventorycheck.vue